/**
 * @classdesc Portuguese Language Pack
 * @desc This class will used to translate tokens into the Portuguese language.
 * @namespace Languages.Portuguese
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Portuguese
 */
export const dictionary = {
	'years'   : 'Anos',
	'months'  : 'Meses',
	'days'    : 'Dias',
	'hours'   : 'Horas',
	'minutes' : 'Minutos',
	'seconds' : 'Segundos'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Portuguese
 */
export const aliases = ['pt', 'pt-br', 'portuguese'];
